import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'

import { getBaseUrl } from '@/lib/contentful/utils'

import { getSeoLocale } from '@/utils/locales/getSeoLocale'
import { useUrl } from '@/utils/url/useUrl'

import { useEntry } from '../AppTier.utils'

export function AppTierMeta() {
	const { locale = 'en-US' } = useRouter()
	const entry = useEntry()

	const url = useUrl({ locale })
	const baseUrl = `${url?.protocol}//${url?.host}`

	if ('error' in entry) return null

	const { seoMetadata, slug } = entry.data

	const includeTitleTemplate = Boolean(seoMetadata?.includeTitleTemplate)
	const title = includeTitleTemplate ? `${seoMetadata?.title} | BigCommerce` : seoMetadata?.title

	return (
		<NextSeo
			title={title ?? undefined}
			description={seoMetadata?.description ?? undefined}
			canonical={seoMetadata?.canonicalUrl || `${baseUrl}/apps/tiers/${slug}/`}
			languageAlternates={[
				{ hrefLang: 'en-au', href: `${getBaseUrl('en-AU')}/apps/tiers/${slug}/` },
				{ hrefLang: 'en-gb', href: `${getBaseUrl('en-GB')}/apps/tiers/${slug}/` },
				{ hrefLang: 'en-us', href: `${getBaseUrl('en-US')}/apps/tiers/${slug}/` },
				{ hrefLang: 'x-default', href: `${getBaseUrl()}/apps/tiers/${slug}/` }
			]}
			openGraph={{
				title: title ?? undefined,
				description: seoMetadata?.description ?? '',
				url: seoMetadata?.canonicalUrl || `${baseUrl}/apps/tiers/${slug}/`,
				images: seoMetadata?.image?.url
					? [
							{
								url: seoMetadata?.image?.url,
								width: seoMetadata?.image?.width,
								height: seoMetadata?.image?.height,
								alt: 'BigCommerce logo',
								type: 'image/jpeg'
							}
					  ]
					: undefined,
				locale: getSeoLocale(locale)
			}}
			nofollow={Boolean(seoMetadata?.nofollow)}
			noindex={Boolean(seoMetadata?.noindex)}
		/>
	)
}
